import SpiceTracker from 'spiceTracker/SpiceTracker';

export default function SpiceTrackerRemote() {
  return <SpiceTracker />;
}
